/* MisHW · comportamiento del tema. Sin dependencias.
   Todo funciona sin JavaScript (formularios normales); esto solo lo hace más ágil. */
(() => {
  const S = window.MisHW || { routes: {}, strings: {} };
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { /* almacenamiento bloqueado */ } },
  };

  /* ---------- Contador del carrito ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.removeAttribute('data-bump');
      void el.offsetWidth; // reinicia la animación
      el.setAttribute('data-bump', '');
    });
  }
  // Autos en el carrito, sin contar la caja de protección
  const PACK = Number(S.packVariant || 0);
  const packQty = (cart) => (cart && cart.items ? cart.items.filter((i) => i.variant_id === PACK).reduce((a, i) => a + i.quantity, 0) : 0);
  const units = (cart) => (cart && typeof cart.item_count === 'number' ? cart.item_count - packQty(cart) : 0);
  async function refreshCount() {
    const res = await fetch(S.routes.cart, { headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const cart = await res.json();
    setCount(units(cart));
    document.dispatchEvent(new CustomEvent('mishw:cart', { detail: cart }));
  }

  /* ---------- Etiqueta del botón con desenfoque breve ---------- */
  function setLabel(btn, text, state) {
    const label = btn.querySelector('.btn-label') || btn;
    const fresh = document.createElement('span');
    fresh.className = 'btn-label';
    fresh.textContent = text;
    label.replaceWith(fresh);
    if (state) btn.dataset.state = state; else delete btn.dataset.state;
  }

  /* ---------- Carrito lateral ---------- */
  const drawer = $('[data-cart-drawer]');
  const DRAWER_ID = 'cart-drawer';
  let lastFocus = null;
  const drawerSection = () => document.getElementById(`shopify-section-${DRAWER_ID}`);

  function paintDrawer(sections) {
    const html = sections && sections[DRAWER_ID];
    const target = drawerSection();
    if (!html || !target) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById(`shopify-section-${DRAWER_ID}`) || doc.body;
    target.innerHTML = fresh.innerHTML;
  }
  function openDrawer() {
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.setAttribute('data-open', '');
    document.documentElement.classList.add('drawer-lock');
    const panel = $('.drawer-panel', drawer);
    requestAnimationFrame(() => ($('[data-drawer-close].drawer-close', drawer) || panel).focus());
    return true;
  }
  function closeDrawer() {
    if (!drawer || !drawer.hasAttribute('data-open')) return;
    drawer.removeAttribute('data-open');
    document.documentElement.classList.remove('drawer-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (drawer) {
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-drawer-close]')) closeDrawer();
    });
    document.addEventListener('keydown', (e) => {
      if (!drawer.hasAttribute('data-open')) return;
      if (e.key === 'Escape') closeDrawer();
      if (e.key === 'Tab') {
        const focusables = $$('a[href], button:not([disabled]), input:not([disabled])', $('.drawer-panel', drawer));
        if (!focusables.length) return;
        const first = focusables[0];
        const last = focusables[focusables.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    // El botón Carrito de la cabecera abre el panel en vez de cambiar de página
    document.addEventListener('click', (e) => {
      const link = e.target.closest('.btn--cart');
      if (!link || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      openDrawer();
    });
    // Cantidades dentro del panel
    let dt;
    const changeLine = async (line, quantity) => {
      const inner = $('[data-drawer-inner]', drawer);
      if (inner) inner.setAttribute('aria-busy', 'true');
      const res = await fetch(S.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: DRAWER_ID }),
      });
      const data = await res.json();
      paintDrawer(data.sections);
      setCount(units(data));
      document.dispatchEvent(new CustomEvent("mishw:cart", { detail: data }));
    };
    drawer.addEventListener('change', (e) => {
      const input = e.target.closest('[data-drawer-qty]');
      if (!input) return;
      clearTimeout(dt);
      dt = setTimeout(() => changeLine(input.dataset.drawerQty, input.value), 280);
    });
    drawer.addEventListener('click', (e) => {
      const rm = e.target.closest('[data-drawer-remove]');
      if (rm) changeLine(rm.dataset.drawerRemove, 0);
    });
  }

  /* ---------- Agregar al carrito (AJAX) ---------- */
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('.js-add-form');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (!btn || btn.dataset.state === 'busy') return;
    const original = (btn.querySelector('.btn-label') || btn).textContent;
    btn.dataset.state = 'busy';
    try {
      const body = new FormData(form);
      if (drawer) body.append('sections', DRAWER_ID);
      const res = await fetch(S.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || S.strings.error);
      setLabel(btn, S.strings.added, 'done');
      if (drawer && data.sections) {
        paintDrawer(data.sections);
        openDrawer();
      }
      await refreshCount();
    } catch (err) {
      setLabel(btn, err.message && err.message.length < 60 ? err.message : S.strings.error, 'error');
    }
    setTimeout(() => setLabel(btn, original), 1700);
  });

  /* ---------- Cantidad: botones − / + ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const input = step.closest('[data-stepper]').querySelector('input');
    const min = Number(input.min || 0);
    const max = input.max ? Number(input.max) : Infinity;
    const next = Math.min(max, Math.max(min, Number(input.value || 0) + Number(step.dataset.step)));
    if (String(next) === input.value) return;
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Carrito: cambiar cantidades sin recargar a ciegas ---------- */
  const cartSection = $('[data-cart-section]');
  if (cartSection) {
    let timer;
    const update = async (line, quantity) => {
      cartSection.setAttribute('aria-busy', 'true');
      const res = await fetch(S.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity), sections: cartSection.dataset.cartSection }),
      });
      const data = await res.json();
      const html = data.sections && data.sections[cartSection.dataset.cartSection];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-section]');
        if (fresh) cartSection.innerHTML = fresh.innerHTML;
      } else {
        location.reload();
      }
      cartSection.removeAttribute('aria-busy');
      setCount(units(data));
      document.dispatchEvent(new CustomEvent("mishw:cart", { detail: data }));
    };
    cartSection.addEventListener('change', (e) => {
      const input = e.target.closest('[data-line-qty]');
      if (!input) return;
      clearTimeout(timer);
      timer = setTimeout(() => update(input.dataset.lineQty, input.value), 280);
    });
    cartSection.addEventListener('click', (e) => {
      const remove = e.target.closest('[data-remove]');
      if (!remove) return;
      e.preventDefault();
      update(remove.dataset.remove, 0);
    });
  }

  /* ---------- Empaque: estándar gratis o caja rígida por pieza ---------- */
  if (PACK) {
    let syncing = false;
    const repaint = (sections) => {
      if (!sections) return;
      paintDrawer(sections);
      const page = $('[data-cart-section]');
      const html = page && sections[page.dataset.cartSection];
      if (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-section]');
        if (fresh) page.innerHTML = fresh.innerHTML;
      }
    };
    const setPack = async (qty, label) => {
      syncing = true;
      const ids = [];
      if (drawerSection()) ids.push(DRAWER_ID);
      const page = $('[data-cart-section]');
      if (page) ids.push(page.dataset.cartSection);
      $$('[data-pack]').forEach((f) => f.setAttribute('aria-busy', 'true'));
      try {
        const body = { updates: { [PACK]: qty } };
        if (ids.length) body.sections = ids.join(',');
        if (label !== undefined) body.attributes = { Empaque: label };
        const res = await fetch(S.routes.cartUpdate, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        repaint(data.sections);
        setCount(units(data));
        document.dispatchEvent(new CustomEvent('mishw:cart', { detail: data }));
      } finally {
        syncing = false;
      }
    };
    document.addEventListener('click', (e) => {
      const pick = e.target.closest('[data-pack-choice]');
      const clear = e.target.closest('[data-pack-clear]');
      if (!pick && !clear) return;
      if (clear) return setPack(0, '');
      const box = pick.dataset.packChoice === '1';
      const n = Number(pick.closest('[data-pack]').dataset.packUnits || 0);
      setPack(box ? n : 0, box ? 'Caja rígida' : 'Estándar');
    });
    // Si cambian las cantidades, la caja sigue al número de autos
    document.addEventListener('mishw:cart', (e) => {
      const cart = e.detail;
      if (syncing || !cart || !cart.items) return;
      const q = packQty(cart);
      const n = units(cart);
      if (q > 0 && q !== n) setPack(n);
    });
  }

  /* ---------- Barra de anuncio: avance al envío gratis ---------- */
  const announce = $('[data-announce]');
  function formatMoney(cents) {
    return '$' + Math.ceil(cents / 100).toLocaleString('es-MX');
  }
  function paintAnnounce(total) {
    if (!announce) return;
    const target = $('[data-announce-text]', announce);
    const threshold = Number(announce.dataset.threshold || 0);
    if (!target || !threshold) return;
    const missing = threshold - total;
    if (total <= 0) target.textContent = announce.dataset.msgStart;
    else if (missing > 0) target.textContent = announce.dataset.msgMissing.replace('[monto]', formatMoney(missing));
    else target.textContent = announce.dataset.msgDone;
  }
  document.addEventListener('mishw:cart', (e) => paintAnnounce(e.detail.total_price));

  /* ---------- Favoritos (en el navegador) ---------- */
  const WISH_KEY = 'mishw-wish';
  const readWish = () => {
    try { return JSON.parse(store.get(WISH_KEY) || '[]'); } catch (e) { return []; }
  };
  const writeWish = (list) => store.set(WISH_KEY, JSON.stringify(list));
  function paintWish() {
    const list = readWish();
    $$('[data-wish]').forEach((btn) => {
      const on = list.includes(btn.dataset.wish);
      btn.setAttribute('aria-pressed', on);
      btn.setAttribute('aria-label', on ? btn.dataset.labelRemove : btn.dataset.labelAdd);
      const t = $('[data-wish-text]', btn);
      if (t) t.textContent = on ? (S.strings.saved || 'Guardado') : (S.strings.save || 'Guardar');
    });
    $$('[data-wish-count]').forEach((el) => {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-wish]');
    if (!btn) return;
    e.preventDefault();
    const list = readWish();
    const h = btn.dataset.wish;
    const i = list.indexOf(h);
    if (i >= 0) list.splice(i, 1); else list.unshift(h);
    writeWish(list.slice(0, 60));
    btn.classList.remove('wish--pop');
    void btn.offsetWidth;
    if (i < 0) btn.classList.add('wish--pop');
    paintWish();
    if (wishGrid && i >= 0) {
      const card = btn.closest('.pcard');
      if (card) card.remove();
      wishEmpty.hidden = readWish().length > 0;
    }
  });
  const wishGrid = $('[data-wishlist-grid]');
  const wishEmpty = $('[data-wishlist-empty]');
  if (wishGrid) {
    const list = readWish();
    wishEmpty.hidden = list.length > 0;
    Promise.all(list.map((h) =>
      fetch(`/products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')
    )).then((parts) => {
      wishGrid.innerHTML = parts.join('');
      wishEmpty.hidden = wishGrid.children.length > 0;
      paintWish();
    });
  }
  paintWish();

  /* ---------- Cuenta regresiva de preventa ---------- */
  $$('[data-countdown]').forEach((box) => {
    const end = new Date(box.dataset.countdown).getTime();
    const out = (k, v) => { const el = $(`[data-cd="${k}"]`, box); if (el) el.textContent = String(v).padStart(2, '0'); };
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      out('d', Math.floor(left / 86400000));
      out('h', Math.floor(left / 3600000) % 24);
      out('m', Math.floor(left / 60000) % 60);
      out('s', Math.floor(left / 1000) % 60);
      if (left === 0) clearInterval(timer);
    };
    const timer = setInterval(tick, 1000);
    tick();
  });

  /* ---------- Cajas misteriosas: repetir la animación ---------- */
  $$('[data-mbox-replay]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const hero = btn.closest('[data-mbox-hero]');
      hero.classList.remove('is-playing');
      void hero.offsetWidth;
      hero.classList.add('is-playing');
    });
  });
  // Las cajas de cada tarjeta se abren cuando entran a la pantalla
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add('is-playing'); io.unobserve(en.target); }
      });
    }, { threshold: 0.4 });
    $$('.mb-card-art[data-mbox-hero], .tb-art[data-mbox-hero]').forEach((el) => io.observe(el));
  } else {
    $$('.mb-card-art[data-mbox-hero], .tb-art[data-mbox-hero]').forEach((el) => el.classList.add('is-playing'));
  }
  $$('.mb-hero[data-mbox-hero]').forEach((el) => el.classList.add('is-playing'));

  /* ---------- Lanzamientos: pestañas ---------- */
  $$('[data-showcase]').forEach((root) => {
    const tabs = $$('[role="tab"]', root);
    const select = (tab) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', on);
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
    };
    tabs.forEach((t, i) => {
      t.tabIndex = i === 0 ? 0 : -1;
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
        next.focus();
        select(next);
      });
    });
  });

  /* ---------- Regla 1:64 ---------- */
  $$('[data-ruler]').forEach((root) => {
    const object = $('.ruler-object', root);
    const cm = $('[data-cm]', root);
    const m = $('[data-m]', root);
    const range = $('[data-range]', root);
    const chips = $$('.chip', root);
    const cars = $$('[data-car]', root);
    const render = (len) => {
      const v = (len * 100) / 64;
      object.style.width = `${v}cm`;
      cm.textContent = `${v.toFixed(1)} cm`;
      if (m) m.textContent = Number(len).toFixed(2);
    };
    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => c.setAttribute('aria-pressed', c === chip));
        cars.forEach((c) => { c.hidden = c.dataset.car !== chip.dataset.index; });
        const len = Number(chip.dataset.length);
        range.value = len;
        render(len);
      });
    });
    range.addEventListener('input', () => {
      chips.forEach((c) => c.setAttribute('aria-pressed', 'false'));
      render(Number(range.value));
    });
  });

  /* ---------- Colección: filtros, orden y vista ---------- */
  const filtersForm = $('[data-filters-form]');
  if (filtersForm) {
    const details = $('[data-filters-details]', filtersForm);
    const mq = window.matchMedia('(max-width: 960px)');
    const syncOpen = () => { if (details) details.open = !mq.matches; };
    syncOpen();
    mq.addEventListener('change', syncOpen);

    let t;
    filtersForm.addEventListener('change', () => {
      clearTimeout(t);
      t = setTimeout(() => filtersForm.requestSubmit(), 350);
    });
    filtersForm.addEventListener('submit', () => {
      // No mandes rangos de precio vacíos
      $$('input[type="number"]', filtersForm).forEach((i) => { if (i.value === '') i.disabled = true; });
    });
  }
  const sort = $('[data-sort-select]');
  if (sort) {
    sort.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      location.href = url.toString();
    });
  }
  const viewTarget = $('[data-view-target]');
  const viewButtons = $$('[data-view]');
  if (viewTarget && viewButtons.length) {
    const apply = (v) => {
      viewTarget.classList.toggle('list', v === 'list');
      viewTarget.classList.toggle('grid', v !== 'list');
      viewTarget.classList.toggle('grid--catalog', v !== 'list');
      viewTarget.querySelectorAll('.pcard').forEach((c) => {
        c.classList.toggle('pcard--list', v === 'list');
        c.classList.toggle('pcard--grid', v !== 'list');
      });
      viewButtons.forEach((b) => b.setAttribute('aria-pressed', b.dataset.view === v));
      store.set('mishw-view', v);
    };
    viewButtons.forEach((b) => b.addEventListener('click', () => apply(b.dataset.view)));
    if (store.get('mishw-view') === 'list') apply('list');
  }

  /* ---------- Producto: variante seleccionada ---------- */
  const variantSelect = $('[data-variant-select]');
  if (variantSelect) {
    variantSelect.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('variant', variantSelect.value);
      location.href = url.toString();
    });
  }

  /* ---------- Recomendaciones ---------- */
  const reco = $('[data-recommendations-url]');
  if (reco) {
    fetch(reco.dataset.recommendationsUrl)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('.related');
        if (section) reco.replaceWith(section);
      })
      .catch(() => {});
  }
})();

/* ==========================================================================
   v2 · Carrera del logo (sections/race-logo.liquid)
   Luces → los autos pasan en grupo → regresan derrapando y trazan el logo → el logo se ilumina.
   ========================================================================== */
(() => {
  const roots = document.querySelectorAll('[data-race]');
  if (!roots.length) return;
  const NS = 'http://www.w3.org/2000/svg';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ease = {
    out: (t) => 1 - Math.pow(1 - t, 3),
    in: (t) => t * t * t,
    inOut: (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
    sine: (t) => -(Math.cos(Math.PI * t) - 1) / 2,
  };
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const DEG = 180 / Math.PI;

  function setup(root) {
    const svg = root.querySelector('.race-svg');
    const cars = [...root.querySelectorAll('.rl-car')];
    const tracks = [...root.querySelectorAll('.rl-track')];
    const gaps = [...root.querySelectorAll('.rl-gap')];
    const smoke = root.querySelector('.race-smoke');
    const lights = [...root.querySelectorAll('.race-light')];
    let raf = 0;
    let puffs = 0;

    const helper = (d) => {
      const p = document.createElementNS(NS, 'path');
      p.setAttribute('d', d);
      p.setAttribute('fill', 'none');
      p.style.visibility = 'hidden';
      svg.appendChild(p);
      return p;
    };

    // trayectorias: entrada desde la izquierda, contorno de la letra, salida por la derecha
    const legs = tracks.map((t, i) => {
      const len = t.getTotalLength();
      const a = t.getPointAtLength(0);
      const b = t.getPointAtLength(Math.min(40, len));
      const lead = helper(`M${-700} ${a.y + (i - 2) * 60} C${a.x - 700} ${a.y + 120} ${a.x - (b.x - a.x) * 10 - 160} ${a.y - (b.y - a.y) * 10} ${a.x} ${a.y}`);
      const exit = helper(`M${a.x} ${a.y} C${a.x + 300} ${a.y - 160} ${3000} ${900 - i * 90} ${3700} ${880 - i * 120}`);
      return { track: t, gap: gaps[i], len, lead, leadLen: lead.getTotalLength(), exit, exitLen: exit.getTotalLength() };
    });

    function place(car, x, y, deg) {
      car.setAttribute('transform', `translate(${x.toFixed(1)} ${y.toFixed(1)}) rotate(${deg.toFixed(1)})`);
    }
    function heading(path, s, len) {
      const p0 = path.getPointAtLength(clamp(s - 8, 0, len));
      const p1 = path.getPointAtLength(clamp(s + 8, 0, len));
      return Math.atan2(p1.y - p0.y, p1.x - p0.x) * DEG;
    }
    function puff(x, y) {
      if (puffs > 46) return;
      const c = document.createElementNS(NS, 'circle');
      c.setAttribute('cx', x.toFixed(1));
      c.setAttribute('cy', y.toFixed(1));
      c.setAttribute('r', '28');
      smoke.appendChild(c);
      puffs++;
      const a = c.animate(
        [{ transform: 'scale(0.4)', opacity: 0.55 }, { transform: 'scale(2.4)', opacity: 0 }],
        { duration: 900 + Math.random() * 300, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' }
      );
      a.onfinish = () => { c.remove(); puffs--; };
    }
    const angDiff = (a, b) => ((b - a + 540) % 360) - 180;

    function finalState() {
      root.classList.add('is-done');
      root.dispatchEvent(new CustomEvent('race:final'));
      legs.forEach((l) => { l.track.style.strokeDashoffset = 0; l.gap.style.strokeDashoffset = 0; });
      cars.forEach((c) => c.setAttribute('transform', 'translate(-900 -900)'));
      lights.forEach((l) => l.classList.add('is-go'));
    }

    function play() {
      cancelAnimationFrame(raf);
      root.classList.remove('is-done', 'is-racing');
      smoke.replaceChildren(); puffs = 0;
      legs.forEach((l) => { l.track.style.strokeDashoffset = 1; l.gap.style.strokeDashoffset = 1; });
      lights.forEach((l) => l.classList.remove('is-on', 'is-go'));
      if (reduce.matches) { finalState(); return; }
      root.dispatchEvent(new CustomEvent('race:start'));
      let announced = false;

      const T0 = performance.now();
      const LIGHT = [0, 320, 640], GO = 1000;
      const RACE = 1050, RACE_DUR = 1500, RACE_STAG = 90;
      const DRAW = 2750, DRAW_STAG = 170, LEAD = 750, TRACE = 2300, EXIT = 650;
      const lanes = [200, 340, 480, 620, 760];
      const state = cars.map(() => ({ yaw: 0, last: 0 }));
      const endAll = DRAW + DRAW_STAG * (cars.length - 1) + LEAD + TRACE + EXIT;

      const frame = (now) => {
        const t = now - T0;
        LIGHT.forEach((at, i) => lights[i].classList.toggle('is-on', t >= at && t < GO));
        if (t >= GO) lights.forEach((l) => l.classList.add('is-go'));
        root.classList.toggle('is-racing', t >= RACE && t < DRAW + 600);

        cars.forEach((car, i) => {
          const st = state[i];
          const leg = legs[i];
          // 1) la carrera: pasan en grupo, con un ligero zigzag
          const tr = (t - RACE - i * RACE_STAG) / RACE_DUR;
          const td = t - DRAW - i * DRAW_STAG;
          if (td < 0) {
            if (tr <= 0 || tr >= 1) { place(car, -900, -900, 0); return; }
            const k = ease.inOut(tr);
            const x = -500 + k * 4200;
            const y = lanes[(i * 2) % 5] + Math.sin(tr * Math.PI * 2 + i) * 40;
            const dy = Math.cos(tr * Math.PI * 2 + i) * 40 * Math.PI * 2 / 4200;
            place(car, x, y, Math.atan(dy) * DEG * 6);
            return;
          }
          // 2) entrada, 3) trazo del contorno, 4) salida
          let path, s, len;
          if (td < LEAD) {
            path = leg.lead; len = leg.leadLen; s = ease.out(td / LEAD) * len;
          } else if (td < LEAD + TRACE) {
            const k = ease.sine((td - LEAD) / TRACE);
            path = leg.track; len = leg.len; s = k * len;
            leg.track.style.strokeDashoffset = 1 - k;
            leg.gap.style.strokeDashoffset = 1 - k;
          } else if (td < LEAD + TRACE + EXIT) {
            leg.track.style.strokeDashoffset = 0; leg.gap.style.strokeDashoffset = 0;
            path = leg.exit; len = leg.exitLen; s = ease.in((td - LEAD - TRACE) / EXIT) * len;
          } else {
            place(car, -900, -900, 0); return;
          }
          const p = path.getPointAtLength(s);
          const h = heading(path, s, len);
          const ahead = heading(path, Math.min(s + 70, len), len);
          const turn = angDiff(h, ahead);
          const target = clamp(turn * 1.6, -38, 38);
          st.yaw += (target - st.yaw) * 0.18;
          const deg = h + st.yaw;
          place(car, p.x, p.y, deg);
          if (Math.abs(st.yaw) > 9 && now - st.last > 45) {
            st.last = now;
            const r = (deg + 180) / DEG;
            puff(p.x + Math.cos(r) * 130, p.y + Math.sin(r) * 130);
          }
        });

        if (t >= endAll - EXIT) {
          root.classList.add('is-done');
          if (!announced) { announced = true; root.dispatchEvent(new CustomEvent('race:done')); }
        }
        if (t < endAll + 200) raf = requestAnimationFrame(frame);
      };
      raf = requestAnimationFrame(frame);
    }

    root.querySelector('[data-race-replay]')?.addEventListener('click', play);
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => { if (e.isIntersecting) { play(); io.disconnect(); } });
      }, { threshold: 0.45 });
      io.observe(root);
    } else {
      finalState();
    }
  }

  roots.forEach(setup);
})();

/* ==========================================================================
   v2 · Portada: del logo dibujado a la carta blíster (sections/hero-race.liquid)
   ========================================================================== */
(() => {
  document.querySelectorAll('[data-hero-race]').forEach((root) => {
    const stage = root.querySelector('.hr-stage');
    const svgLogo = root.querySelector('.race-logo');
    const slotImg = root.querySelector('.hr-slot img');
    const fly = root.querySelector('.hr-fly');
    const STEPS = ['is-pack', 'is-logo', 'is-winner', 'is-final'];
    let timers = [];
    const later = (ms, fn) => timers.push(setTimeout(fn, ms));
    const reset = () => {
      timers.forEach(clearTimeout); timers = [];
      fly.getAnimations().forEach((a) => a.cancel());
      fly.style.opacity = '0';
      root.classList.remove(...STEPS, 'is-flying');
    };

    function flyLogo(done) {
      const s = stage.getBoundingClientRect();
      const a = svgLogo.getBoundingClientRect();
      // destino según el layout final de la carta (sin la transformación de entrada)
      const pk = root.querySelector('.hr-pack').getBoundingClientRect();
      const slot = slotImg.parentElement;
      const b = { left: pk.left + slot.offsetLeft, top: pk.top + slot.offsetTop, width: slot.offsetWidth, height: slot.offsetHeight };
      // la imagen del slot es "contain": calcula el rectángulo real del logo dentro
      const ratio = 2753 / 693;
      let bw = b.width, bh = b.width / ratio;
      if (bh > b.height) { bh = b.height; bw = bh * ratio; }
      const bx = b.left + (b.width - bw) / 2, by = b.top + (b.height - bh) / 2;
      Object.assign(fly.style, { left: `${a.left - s.left}px`, top: `${a.top - s.top}px`, width: `${a.width}px`, height: `${a.height}px`, opacity: '1' });
      root.classList.add('is-flying');
      const k = bw / a.width;
      const dx = bx - a.left, dy = by - a.top;
      const anim = fly.animate([
        { transform: 'translate(0, 0) scale(1)' },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 40}px) scale(${1 - (1 - k) * 0.55}) rotate(-2deg)`, offset: 0.5 },
        { transform: `translate(${dx}px, ${dy}px) scale(${k})` },
      ], { duration: 1050, easing: 'cubic-bezier(0.2, 0, 0, 1)', fill: 'forwards' });
      anim.onfinish = () => { done(); later(60, () => { fly.style.opacity = '0'; }); };
    }

    root.addEventListener('race:start', () => { root.dataset.started = '1'; reset(); });
    root.addEventListener('race:final', () => { root.dataset.started = '1'; reset(); root.classList.add(...STEPS); });
    root.addEventListener('race:done', () => {
      later(350, () => root.classList.add('is-pack'));
      later(450, () => flyLogo(() => {
        root.classList.add('is-logo');
        later(250, () => root.classList.add('is-winner'));
        later(1100, () => root.classList.add('is-final'));
      }));
    });
  });
})();

/* ==========================================================================
   v3 · Galería del producto: miniaturas + foto ampliada con zoom
   ========================================================================== */
(() => {
  const data = document.querySelector('[data-gallery-json]');
  const dialog = document.querySelector('[data-zoom-dialog]');
  if (!data || !dialog) return;
  let photos = [];
  try { photos = JSON.parse(data.textContent); } catch (e) { return; }
  if (!photos.length) return;

  const bubble = document.querySelector('.pdp-blister .blister-bubble');
  const main = bubble && bubble.querySelector('.blister-photo');
  const thumbs = [...document.querySelectorAll('[data-thumb]')];
  const stage = dialog.querySelector('[data-zoom-stage]');
  const img = dialog.querySelector('[data-zoom-img]');
  const count = dialog.querySelector('[data-zoom-count]');
  const ZOOM = 2.6;
  let current = 0;
  let zoomed = false;

  function showMain(i) {
    current = i;
    thumbs.forEach((t, k) => t.setAttribute('aria-pressed', k === i ? 'true' : 'false'));
    if (!main) return;
    main.removeAttribute('srcset');
    main.removeAttribute('sizes');
    main.animate([{ opacity: 0.35, transform: 'scale(0.97)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'cubic-bezier(0.2, 0, 0, 1)' });
    main.src = photos[i].main;
    main.alt = photos[i].alt;
  }

  function setZoom(on, x = 0.5, y = 0.5) {
    zoomed = on;
    stage.classList.toggle('is-zoomed', on);
    img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
    img.style.transform = on ? `scale(${ZOOM})` : '';
  }
  function load(i) {
    current = (i + photos.length) % photos.length;
    setZoom(false);
    img.src = photos[current].large;
    img.alt = photos[current].alt;
    count.textContent = `${current + 1} / ${photos.length}`;
    dialog.classList.toggle('is-single', photos.length < 2);
  }
  function open() {
    load(current);
    if (typeof dialog.showModal === 'function') dialog.showModal(); else dialog.setAttribute('open', '');
    document.documentElement.classList.add('is-locked');
  }
  function close() {
    setZoom(false);
    if (dialog.open && typeof dialog.close === 'function') dialog.close(); else dialog.removeAttribute('open');
  }
  dialog.addEventListener('close', () => document.documentElement.classList.remove('is-locked'));

  thumbs.forEach((t) => t.addEventListener('click', () => showMain(Number(t.dataset.thumb))));

  if (bubble && main) {
    bubble.classList.add('is-zoomable');
    bubble.setAttribute('role', 'button');
    bubble.setAttribute('tabindex', '0');
    bubble.setAttribute('aria-label', dialog.dataset.openLabel || 'Ampliar foto');
    bubble.addEventListener('click', open);
    bubble.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  }

  // zoom: un toque acerca en ese punto; mover el puntero recorre la foto; otro toque aleja
  const point = (e) => {
    const r = stage.getBoundingClientRect();
    const p = e.touches ? e.touches[0] : e;
    return [Math.min(1, Math.max(0, (p.clientX - r.left) / r.width)), Math.min(1, Math.max(0, (p.clientY - r.top) / r.height))];
  };
  stage.addEventListener('click', (e) => { const [x, y] = point(e); setZoom(!zoomed, x, y); });
  stage.addEventListener('pointermove', (e) => {
    if (!zoomed) return;
    const [x, y] = point(e);
    img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  });
  stage.addEventListener('touchmove', (e) => {
    if (!zoomed) return;
    e.preventDefault();
    const [x, y] = point(e);
    img.style.transformOrigin = `${x * 100}% ${y * 100}%`;
  }, { passive: false });

  dialog.querySelector('[data-zoom-close]').addEventListener('click', close);
  dialog.querySelector('[data-zoom-prev]').addEventListener('click', () => load(current - 1));
  dialog.querySelector('[data-zoom-next]').addEventListener('click', () => load(current + 1));
  dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });
  dialog.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') load(current - 1);
    if (e.key === 'ArrowRight') load(current + 1);
  });
})();

/* ---------- Colección: filtros visuales (marca, tipo, color, versión, precio) ---------- */
(() => {
  const root = document.querySelector('[data-fx]');
  const panel = document.querySelector('[data-fx-panel]');
  if (!root || !panel) return;
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const LIST_KEYS = ['marca', 'tipo', 'color', 'anio', 'serie', 'edicion'];
  const KEYS = LIST_KEYS.concat(['stock', 'precio']);

  const items = $$('[data-fx-item]', root).map((el) => {
    const d = { el, stock: el.dataset.stock, precio: Number(el.dataset.precio) || 0 };
    LIST_KEYS.forEach((k) => { d[k] = (el.dataset[k] || '').split(' ').filter(Boolean); });
    return d;
  });
  const opts = $$('[data-fx-key]', panel);
  const state = {};
  KEYS.forEach((k) => { state[k] = new Set(); });

  // Estado inicial desde la URL (?marca=ford,bmw&tipo=pickups)
  const params = new URLSearchParams(location.search);
  KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) v.split(',').forEach((x) => state[k].add(x));
  });

  const inRange = (price, r) => { const [a, b] = r.split('-').map(Number); return price >= a && price <= b; };
  const passes = (it, k) => {
    const sel = state[k];
    if (!sel.size) return true;
    if (k === 'stock') return it.stock === 'si';
    if (k === 'precio') return [...sel].some((r) => inRange(it.precio, r));
    return it[k].some((v) => sel.has(v));
  };
  const matches = (it, except) => KEYS.every((k) => k === except || passes(it, k));
  const has = (it, k, v) => {
    if (k === 'stock') return it.stock === 'si';
    if (k === 'precio') return inRange(it.precio, v);
    return it[k].includes(v);
  };

  const labelOf = (k, v) => {
    const o = opts.find((b) => b.dataset.fxKey === k && b.dataset.fxVal === v);
    return o ? (o.dataset.fxLabel || o.textContent.trim()) : v;
  };

  const chips = root.querySelector('[data-fx-chips]');
  const empty = root.querySelector('[data-fx-empty]');
  const badge = root.querySelector('[data-fx-badge]');
  const counts = $$('[data-fx-count]');
  const resets = $$('[data-fx-clear]');

  function render() {
    let shown = 0;
    items.forEach((it) => {
      const ok = matches(it);
      it.el.hidden = !ok;
      if (ok) shown += 1;
    });
    counts.forEach((c) => { c.textContent = shown; });
    if (empty) empty.hidden = shown > 0;

    opts.forEach((b) => {
      const k = b.dataset.fxKey;
      const v = b.dataset.fxVal;
      const n = items.filter((it) => matches(it, k) && has(it, k, v)).length;
      const on = state[k].has(v);
      b.setAttribute('aria-pressed', on);
      b.classList.toggle('is-zero', n === 0 && !on);
      const nEl = b.querySelector('[data-fx-n]');
      if (nEl) nEl.textContent = n;
    });

    let active = 0;
    const chipHtml = [];
    KEYS.forEach((k) => state[k].forEach((v) => {
      active += 1;
      chipHtml.push(`<button type="button" class="fx-chip" data-chip-key="${k}" data-chip-val="${v}">${labelOf(k, v)}<svg class="icon" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>`);
    }));
    if (chips) {
      chips.hidden = active === 0;
      chips.innerHTML = active ? chipHtml.join('') + `<button type="button" class="fx-chip fx-chip--clear" data-chip-clear>${(window.MisHW && MisHW.strings && MisHW.strings.clearFilters) || 'Quitar filtros'}</button>` : '';
    }
    if (badge) { badge.hidden = active === 0; badge.textContent = active; }
    resets.forEach((r) => { if (r.classList.contains('fx-reset')) r.hidden = active === 0; });
    $$('[data-fx-sel]', panel).forEach((s) => {
      const n = s.dataset.fxSel.split(' ').reduce((a, k) => a + state[k].size, 0);
      s.textContent = n ? n : '';
    });

    const url = new URL(location.href);
    KEYS.forEach((k) => { if (state[k].size) url.searchParams.set(k, [...state[k]].join(',')); else url.searchParams.delete(k); });
    history.replaceState(null, '', url);
  }

  opts.forEach((b) => b.addEventListener('click', () => {
    const s = state[b.dataset.fxKey];
    const v = b.dataset.fxVal;
    if (s.has(v)) s.delete(v); else s.add(v);
    render();
  }));
  const clearAll = () => { KEYS.forEach((k) => state[k].clear()); render(); };
  resets.forEach((r) => r.addEventListener('click', clearAll));
  if (chips) chips.addEventListener('click', (e) => {
    const c = e.target.closest('button');
    if (!c) return;
    if (c.hasAttribute('data-chip-clear')) return clearAll();
    state[c.dataset.chipKey].delete(c.dataset.chipVal);
    render();
  });

  // Marcas: las más surtidas primero, 9 visibles y buscador
  const brandsBox = panel.querySelector('[data-fx-brands]');
  if (brandsBox) {
    const tiles = $$('.fx-brand', brandsBox);
    tiles.sort((a, b) => items.filter((it) => it.marca.includes(b.dataset.fxVal)).length - items.filter((it) => it.marca.includes(a.dataset.fxVal)).length)
      .forEach((t) => brandsBox.appendChild(t));
    const more = panel.querySelector('[data-fx-more]');
    const search = panel.querySelector('[data-fx-brand-search]');
    let open = false;
    const layout = () => {
      const q = search ? search.value.trim().toLowerCase() : '';
      let i = 0;
      tiles.forEach((t) => {
        const hit = !q || (t.dataset.fxLabel || '').toLowerCase().includes(q);
        const pressed = t.getAttribute('aria-pressed') === 'true';
        t.hidden = !hit || (!q && !open && i >= 9 && !pressed);
        if (hit) i += 1;
      });
      if (more) {
        more.hidden = !!q;
        more.setAttribute('aria-expanded', open);
        more.textContent = open ? more.dataset.less : more.dataset.more;
      }
    };
    if (more) more.addEventListener('click', () => { open = !open; layout(); });
    if (search) search.addEventListener('input', layout);
    brandsBox.addEventListener('click', () => setTimeout(layout));
    layout();
  }

  // Series: 6 visibles
  const seriesBox = panel.querySelector('[data-fx-series]');
  const moreSeries = panel.querySelector('[data-fx-more-series]');
  if (seriesBox && moreSeries) {
    let open = false;
    const rows = $$('.fx-row', seriesBox);
    const layout = () => {
      rows.forEach((r, i) => { r.hidden = !open && i >= 6 && r.getAttribute('aria-pressed') !== 'true'; });
      moreSeries.setAttribute('aria-expanded', open);
      moreSeries.textContent = open ? moreSeries.dataset.less : moreSeries.dataset.more;
    };
    moreSeries.addEventListener('click', () => { open = !open; layout(); });
    layout();
  }

  // Panel como hoja lateral en celular
  const opener = root.querySelector('[data-fx-open]');
  const scrim = root.querySelector('.fx-scrim');
  const mq = window.matchMedia('(max-width: 960px)');
  const setOpen = (on) => {
    panel.toggleAttribute('data-open', on);
    if (scrim) scrim.hidden = !on;
    document.documentElement.classList.toggle('drawer-lock', on);
    if (opener) opener.setAttribute('aria-expanded', on);
    if (on) { const f = panel.querySelector('.fx-close'); if (f) f.focus(); } else if (opener && mq.matches) opener.focus();
  };
  if (opener) opener.addEventListener('click', () => setOpen(true));
  $$('[data-fx-close]', root).forEach((c) => c.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && panel.hasAttribute('data-open')) setOpen(false); });
  mq.addEventListener('change', () => { if (!mq.matches) setOpen(false); });

  render();
})();
